// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__IrifH","productName":"Table_productName__BKDKM"};